import image1 from './Images/AnupProfile.jpg'
import image2 from './Images/AshokProfile.png'
import image3 from './Images/BibekProfile.png'
import image4 from './Images/prayashProfile.png'
const ourintro = [
    {
        Name:"Anup Bashyal",
        imageurl:image1,
        Age:21,
        Description:"Lorem ipsum dolor sit amet consectetur, adipisicing elit. Expedita, dignissimos soluta. Explicabo officia praesentium illum culpa quo, nostrum cupiditate .... "
    },
    {
        Name:"Ashok pandey",
        imageurl:image2,
        Age:21,
        Description:"Lorem ipsum dolor sit amet consectetur, adipisicing elit. Expedita, dignissimos soluta. Explicabo officia praesentium illum culpa quo, nostrum cupiditate .... "
    },
    {
        Name:"Bibek Timilsina",
        imageurl:image3,
        Age:21,
        Description:"Lorem ipsum dolor sit amet consectetur, adipisicing elit. Expedita, dignissimos soluta. Explicabo officia praesentium illum culpa quo, nostrum cupiditate .... "
    },
    {
        Name:"Prayash Mishra",
        imageurl:image4,
        Age:21,
        Description:"Lorem ipsum dolor sit amet consectetur, adipisicing elit. Expedita, dignissimos soluta. Explicabo officia praesentium illum culpa quo, nostrum cupiditate .... "
    }
]

export default ourintro;